import { render, staticRenderFns } from "./event-item-address.vue?vue&type=template&id=4667b9c9&"
import script from "./event-item-address.vue?vue&type=script&lang=js&"
export * from "./event-item-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports